import * as React from 'react'
import styled from 'styled-components'
import { PaymentRequestButtonElement } from '@stripe/react-stripe-js'
import type { SubscriptionLengthType } from '../../../../../flowTypes'
import { CTASecondaryWhite, colors } from '@components/shared'

export type PropsType = {
  stripe: any,
  plan?: SubscriptionLengthType,
  price: string,
  subscribe: (altPaymentEvent: any) => void,
  isPrimaryWhite?: boolean,
  trialDays: number
}

type TokenEventType = {
  token: string
}

export default function PaymentRequestButton (props: PropsType): React.ReactNode {
  const [paymentRequest, setPaymentRequest] = React.useState<any>(null)
  const [isApplePay, setIsApplePay] = React.useState(false)

  React.useEffect((): void => {
    const plan = props.plan
    if (props.stripe && plan) {
      const priceString = props.price.replace(/[$|.]/g, '')
      const priceInt = parseInt(String(priceString || 69.99))

      const displayItems: any[] = []

      if (!!props.trialDays && props.trialDays > 0) {
        displayItems.push({
          amount: 0,
          label: `${props.trialDays} Day Free Trial`
        })
      }

      let subscriptionLengthText = 'Subscription'
      if (plan === 'annual') {
        subscriptionLengthText = 'Annual subscription'
      } else if (plan === 'monthly') {
        subscriptionLengthText = 'Monthly subscription'
      }

      if (!paymentRequest) {
        const pr = props.stripe.paymentRequest({
          country: 'US',
          currency: 'usd',
          total: {
            label: subscriptionLengthText,
            amount: priceInt
          },
          requestPayerName: true,
          requestPayerEmail: true,
          displayItems
        })
        pr.on('token', async (event: TokenEventType): Promise<void> => {
          props.subscribe(event)
        })
        pr.canMakePayment().then((result: any): void => {
          if (result) {
            if (result.applePay) {
              setIsApplePay(true)
            }
            setPaymentRequest(pr)
          }
        })
      } else {
        paymentRequest.update({
          total: {
            label: subscriptionLengthText,
            amount: priceInt
          }
        })
        setPaymentRequest(paymentRequest)
      }
    }
  }, [props.stripe, props.price, props.plan])

  const handlePayment = (e: any): void => {
    e.preventDefault()
    if (paymentRequest) {
      paymentRequest.show()
    }
  }

  if (paymentRequest) {
    return (
      <AltPaymentContainer>
        {isApplePay
          ? (
          <PaymentRequestButtonElement options={{ paymentRequest, style: { paymentRequestButton: { theme: 'light', height: '40px' } } }} />
            )
          : (
          <PayWithCardButton
            onClick={handlePayment}
            isPrimaryWhite={props.isPrimaryWhite}
          >
            Pay with saved card
          </PayWithCardButton>
            )}
      </AltPaymentContainer>
    )
  }
  return <div />
}

const PayWithCardButton = styled(CTASecondaryWhite)<any>`
  height: 40px;
  ${(props: { isPrimaryWhite: boolean}): string | null | undefined => {
    if (props.isPrimaryWhite) {
      return `
        background-color: ${colors.white};
        color: ${colors.midnightBlue};
      `
    }
  }}
`
const AltPaymentContainer = styled.div<any>`
  margin: 20px 0 10px;
  width: 100%;
`
